import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { Step } from "../types";

interface PageHeaderProps {
  currentStep: Step;
}

export const PageHeader: React.FC<PageHeaderProps> = ({ currentStep }) => {
  return (
    <>
      <Grid item xs={12} mb={1.5}>
        <Typography variant="h5" fontWeight="500" sx={{ fontSize: '20px' }}>
          Send To Entrata
        </Typography>
      </Grid>

      <Grid item xs={12} mb={2}>
        <Typography variant="body1" sx={{ fontSize: '14px', color: '#424242' }}>
          Export roommate groups created in RoomSync to Entrata.
        </Typography>
      </Grid>

      <Grid item mb={3}>
        <Box sx={{
          bgcolor: '#FFF8E1',
          p: 2,
          borderRadius: '4px',
          border: '1px solid #FFE082'
        }}>
          <Box component="ul" sx={{
            m: 0,
            pl: 3,
            '& li': {
              fontSize: '14px',
              color: '#424242',
              mb: 0.5
            }
          }}>
            <li>Residents already assigned to a unit in Entrata will not be exported</li>
            <li>Residents already in a roommate group in Entrata will not be exported</li>
          </Box>
        </Box>
      </Grid>
    </>
  );
};
